import { useRefreshOffers } from 'hooks/loyalty/use-refresh-offers';

import { hasOffers } from '../utils';

import { useCartContext } from './use-cart-context';

export const useInitLoyaltyDependencies = () => {
  const { cartEntries } = useCartContext();
  useRefreshOffers({ skip: !hasOffers(cartEntries) });
};
